export default class Task {
  constructor(public description: string, public duration: number, public startDate: Date) {}
}

export const TaskCategories = [
  'Delivery',
  'Cleaning',
  'Event Planning',
  'Event Staffing',
  'Personal Assistant',
  'Entertainment',
  'Furniture Assembly',
  'Heavy Lifting',
  'Minor Home Repairs',
  'Help Moving',
  'Organization',
  'Accounting',
  'Arts & Crafts',
  'Automotive',
  'Carpentry & Construction',
  'Computer Help',
  'Cooking Baking',
  'Data Entry',
  'Decoration',
  'Deep Clean',
  'Electrician',
  'Errands',
  'Graphic Design',
  'Laundry & Ironing',
  'Marketing',
  'Mounting',
  'Office Administration',
  'Packing & Shipping',
  'Painting',
  'Pet Sitting',
  'Photography',
  'Plumbing',
  'Research',
  'Selling Online',
  'Sewing',
  'Shopping',
  'Usability Testing',
  'Videography',
  'Web Design & Development',
  'Wait In Line',
  'Window Cleaning',
  'Writing & Editing',
  'YardWork & Removal'
];
